module.exports = __webpack_public_path__ + "static/media/kick.4dd58595.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row3/kick.wav
// module id = 67
// module chunks = 0